import { useState } from "react";

import { Box, Card, CardBody, CardHeader, Heading, Text, VStack, useColorModeValue } from "@chakra-ui/react";
import { format } from "date-fns";

import { RbtiInputForm } from "./RbtiInputForm";

import { useAppState } from "~/hooks/useAppState";

interface RBTIFormData {
  [key: string]: string;
}

interface FieldStatus {
  [key: string]: string;
}

export const Rbti = () => {
  const [fieldStatuses, setFieldStatuses] = useState<FieldStatus>({});
  const { currentMember } = useAppState("currentMember");

  // Color mode values
  const cardBg = useColorModeValue("white", "gray.700");
  const cardBorder = useColorModeValue("gray.200", "gray.600");
  const comingSoonColor = useColorModeValue("blue.700", "blue.300");

  const handleSubmit = (data: RBTIFormData) => {
    console.log(data);
  };

  const handleFieldStatusChange = (fieldName: string, status: string) => {
    setFieldStatuses((prev) => ({
      ...prev,
      [fieldName]: status
    }));
  };

  if (!currentMember) {
    return (
      <Box p={4} textAlign="center">
        <Text>Please select a member from the dropdown above to view RBTI data.</Text>
      </Box>
    );
  }

  return (
    <VStack align="stretch" spacing={6} p={4}>
      <Box>
        <Heading size="lg" mb={2}>
          Reams Biological Theory of Ionization Testing
        </Heading>
        <Text color="gray.600">RBTI testing data for {format(new Date(), "MM-dd-yyyy")}</Text>
      </Box>

      {/* Coming Soon Message */}
      <Card variant="outline" bg={cardBg} borderColor={cardBorder} boxShadow="md">
        <CardHeader>
          <Heading size="md" color={comingSoonColor}>
            RBTI Testing - Coming Soon
          </Heading>
        </CardHeader>
        <CardBody>
          <Text fontSize="md">
            We're currently enhancing our RBTI testing capabilities. This feature will be available in an upcoming
            update.
          </Text>
          <Text mt={4} fontSize="sm" fontStyle="italic">
            RBTI (Reams Biological Theory of Ionization) testing helps analyze body chemistry through various
            measurements including urine and saliva pH, conductivity, and other key indicators.
          </Text>
        </CardBody>
      </Card>

      {/* Display the input form so users can see what it will look like */}
      <RbtiInputForm
        onSubmit={handleSubmit}
        fieldStatuses={fieldStatuses}
        onFieldStatusChange={handleFieldStatusChange}
      />
    </VStack>
  );
};

export default Rbti;
